export const SIGN_IN_CONTENT = {
    title: "Sign in to Milir Account",
    pwdResetTxt: "Forgot password?",
    formSubmit: "Sign in",
    newCustomer: "Sign up"
    
}

export const SIGN_UP_CONTENT = {
    title: "Create Your Milir Account Today",
    formSubmit: "Sign up",
    OrganizationTitle: "Setup your organization",
    VerifyTitle: "Please Verify your Email address",
    VerifyContent: "Click Verify to continue setup account",
}

export const ExtensionContent = {
    extensionInstalltionContent: <div>
        <p className="my-6 text-xl leading-8">To enhance your experience and unlock all features of our dashboard, please install our Chrome extension.</p>
        <div className="mt-10 max-w-2xl">
        <p className="my-6 text-lg leading-8">Steps to install</p>
        <ul role="list" className="mt-3 max-w-xl space-y-8 text-gray-600">
          <li className="flex gap-x-3">
            <svg className="mt-1 h-5 w-5 flex-none text-indigo-600" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
            </svg>
            <span><strong className="font-semibold text-gray-900">Step 1.</strong> Click the button below to go to the Chrome Web Store..</span>
          </li>
          <li className="flex gap-x-3">
            <svg className="mt-1 h-5 w-5 flex-none text-indigo-600" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
            </svg>
            <span><strong className="font-semibold text-gray-900">Step 2.</strong> Click "Add to Chrome" and then confirm by clicking "Add extension".</span>
          </li>
        </ul>
      </div>
      <div className=" text-center">
        <a href="#" className="rounded-md bg-indigo-600 px-3 py-3 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Click</a>
      </div>
    </div>,
    sectionTitle:"Why Install Our Chrome Extension?",
    description:"We're thrilled to have you here as part of our community! To enhance your onboarding experience and unlock the full potential of Milir, we highly recommend installing our Chrome extension."
    ,
    descList: [
        {
          title: 'Seamless Integration:',
          content:
            'The extension seamlessly integrates with your Chrome browser, ensuring a smooth onboarding process without any interruptions.',
        },
        {
          title: 'Effortless Scanning:',
          content:
            'With our extension, scanning pages for relevant information becomes effortless. Simply activate it, and let it do the heavy lifting for you.',
        },
        {
          title: "Enhanced Productivity:",
          content: "Say goodbye to manual data entry and tedious processes. Our extension automates tasks, saving you time and effort."
        },
        {
          title: "Stay Updated:",
          content: "Receive real-time updates and notifications, keeping you informed about important onboarding milestones and updates."
        }
      ],
      sectionList:[
        {
          title: "How to Install",
          content: <ol className="ps-5 mt-2 space-y-1 list-decimal list-inside">
              <li>Click here to install the extension from the Chrome Web Store.</li>
              <li>Follow the on-screen instructions to complete the installation process.</li>
              <li>Once installed, refresh your onboarding page, and you're all set!</li>
          </ol>
        },
        {
          title:"Need Help?",
          content: "If you encounter any issues during the installation process or have any questions about our Chrome extension, our support team is here to assist you. Feel free to reach out to us at milir@mavencart.com for prompt assistance."
        },
        {
          title: "Let's Get Started!",
          content: "Enhance your onboarding journey with our Chrome extension and unlock a world of possibilities. Thank you for choosing Milir. We're excited to embark on this journey with you!"
        }
      ]
}

export const includedFeatures = [
  'CDN Tracking feature access',
  'Customer support',
  'Feature tracking',
  'Unlimited user tracking',
]

export const MonthlySubscription = {
  title: "Monthly",
  content: "Lorem ipsum dolor sit amet consect etur adipisicing elit. Itaque amet indis perferendis blanditiisrepellendus etur quidem assumenda.",
  includedFeatures,
  amount: "15",
  currency: "inr"
}
export const YearlySubscription = {
  title: "Annual",
  content: "Lorem ipsum dolor sit amet consect etur adipisicing elit. Itaque amet indis perferendis blanditiisrepellendus etur quidem assumenda.",
  includedFeatures,
  amount: "60",
  currency: "inr"
}
